jQuery(document).ready(function ($) {
	let wWidth = $(window).width();
	let navState = false;
	const $header = $('.header');
	const $nav = $header.find('.nav');
	const $parentLi = $nav.find('.menu-item-has-children');
	const $parentLinks = $parentLi.children('a');
	const $subMenus = $parentLi.children('.sub-menu');
	let isObserver = true;
	let observer;
	let isTouch;

	if (
			!('IntersectionObserver' in window) ||
			!('IntersectionObserverEntry' in window) ||
			!('isIntersecting' in window.IntersectionObserverEntry.prototype)
	) {
		isObserver = false;
		$('html').removeClass('is-observer');
	}

	if (isObserver) {
		observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('is-visible');
							observer.unobserve(entry.target);
						}
					});
				},
				{ rootMargin: '0px 0px -15% 0px' }
		);
	}

	function isTouchDevice() {
		const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
		const mq = (query) => {
			return window.matchMedia(query).matches;
		};

		if (
				'ontouchstart' in window ||
				// eslint-disable-next-line no-undef
				(window.DocumentTouch && document instanceof DocumentTouch)
		) {
			return true;
		}

		// include the 'heartz' as a way to have a non matching MQ to help terminate the join
		// https://git.io/vznFH
		const query = [
			'(',
			prefixes.join('touch-enabled),('),
			'heartz',
			')',
		].join('');
		return mq(query);
	}

	if (isTouchDevice()) {
		isTouch = true;
		$('html').addClass('is-touch');
	}

	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate, ...args) {
		let timeout;
		return function () {
			const context = this;
			const later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	// function disableScrolling() {
	//   if ($(document).height() > $(window).height()) {
	//     const scrollTop = $('html').scrollTop()
	//       ? $('html').scrollTop()
	//       : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
	//     $('html')
	//       .addClass('disable-scrolling')
	//       .css('top', -scrollTop);
	//   }
	// }

	// function enableScrolling() {
	//   const scrollTop = parseInt($('html').css('top'), 10);
	//   $('html').removeClass('disable-scrolling');
	//   $('html,body').scrollTop(-scrollTop);
	// }

	// TODO: test if all good with vanilla JS repalcement
	function disableScrolling() {
		const docHeight = document.body.clientHeight;
		const windowHeight = window.innerHeight;

		if (docHeight > windowHeight) {
			const html = document.documentElement;
			const { scrollTop } = html;
			html.classList.add('disable-scrolling');
			html.style.top = `${-scrollTop}px`;
		}
	}

	function enableScrolling() {
		const { top } = getComputedStyle(document.documentElement);
		const scrollTop = parseInt(top, 10);
		const html = document.documentElement;
		html.classList.remove('disable-scrolling');
		html.scrollTop = -scrollTop;
	}

	function handleNavTouch(e) {
		const $item = $(e.target);
		const $curSubMenu = $item.siblings('.sub-menu');

		if ($item.parent().hasClass('is-opened')) {
			$item.parent().removeClass('is-opened');

			if (wWidth < 1280) {
				$curSubMenu.slideUp();
			}
		} else {
			$parentLi.removeClass('is-opened');
			$item.parent().addClass('is-opened');

			if (wWidth < 1280) {
				$subMenus.slideUp();
				$curSubMenu.slideDown();
			}
		}
	}

	function bindEvents() {
		// $('.hamburger').on('click', () => {
		//   if (navState) {
		//     $header.removeClass('is-opened');
		//     enableScrolling();
		//   } else {
		//     $header.addClass('is-opened');
		//     disableScrolling();
		//   }
		//   navState = !navState;
		// });

		$parentLinks.on('touchend', (e) => {
			e.preventDefault();
			handleNavTouch(e);
		});

		/* Navigation with tabbing */
		$(window).keyup((e) => {
			const code = e.keyCode ? e.keyCode : e.which;

			if (code === 9) {
				if ($parentLinks.filter(':focus').length) {
					handleNavTouch(e);
				} else {
					const link = $nav.find('a:focus');

					if (
							link.length &&
							!link.parent().hasClass('.menu-item-has-children') &&
							!link.closest('.sub-menu').length
					) {
						$parentLi.removeClass('is-opened');
						$parentLi.children('.sub-menu').slideUp();
					}
				}
			}
		});

		// FOCUS STYLING
		// Let the document know when the mouse is being used
		document.body.addEventListener('mousedown', () => {
			document.body.classList.remove('is-tab');
		});

		// Re-enable focus styling when Tab is pressed
		document.body.addEventListener('keydown', (event) => {
			if (event.key === 'Tab') {
				document.body.classList.add('is-tab');
			}
		});
	}

	const doneResizing = debounce(() => {
		const width = $(window).width();

		if (wWidth !== width) {
			wWidth = width;
		}
	}, 500);

	/* FUNCTION CALLS */
	/* ============= */
	bindEvents();

	if (isObserver) {
		$('.js-visibility').each((i, el) => {
			observer.observe(el);
		});
	}

	$(window).on('scroll', () => {});
	$(window).on('resize', doneResizing);

	function headerHeight() {
		var scroll = $(window).scrollTop();
		if (scroll >= 100) $('header.header').addClass('header--small');
		else $('header.header').removeClass('header--small');
	}
	headerHeight();

	$(window).scroll(function () {
		headerHeight();
	});

	$('.hamburger').on('click', () => {
		if ($('body').hasClass('is-opened')) {
			// $("header.header").removeClass('header--opened');
			$('body').removeClass('is-opened');
			enableScrolling();
		} else {
			// $("header.header").addClass('header--opened');
			$('body').addClass('is-opened');
			disableScrolling();
		}
	});

	$('.slideout .menu-item-has-children a').click( function(e) {
		e.preventDefault();

		var submenu = $(this).parents('.menu-item').find('.sub-menu');
		console.log( $(this));
		console.log( $(this).parents('.menu-item').find('.sub-menu') );
		if (submenu.hasClass('active')) {
			submenu.removeClass('active');
		} else {
			submenu.addClass('active');
		}
	});

	$(".btn").on("click", function (event) {
		if ($(this).attr("href") == "#sign-up") {
			event.preventDefault();

			$(".sign-up-modal").show();
		}
	});

	$(".sign-up-modal__close-btn").on("click", function () {
		$(".sign-up-modal").hide();
	});

	// HIDE CONTACT AFTER SUBMIT
	document.addEventListener(
			'wpcf7mailsent',
			function (event) {
				document
						.querySelectorAll(
								'form.wpcf7-form > :not(.wpcf7-response-output)'
						)
						.forEach((el) => {
							el.style.display = 'none';
						});
			},
			false
	);

	$('form.wpcf7-form .input__wrap .wpcf7-select').select2({
		placeholder:'How many Sites?',
		minimumResultsForSearch: Infinity,
		theme: 'theme--lkn',
	});
});

jQuery(document).ready(function($) {
	var owl = $('.section--contact .gallery__container'),
			owlOptions = {
				loop: true,
				nav: false,
				items: 1,
				responsive:{
					0:{
						margin: 30,
					},
					480:{
						margin: 50,
					},
					768:{
						margin: 60,
					},
				}
			};

	if ( $(window).width() < 1024 ) {
		owl.owlCarousel(owlOptions);
		owl.addClass('owl-carousel');
	} else {
		owl.removeClass('owl-carousel');
	}

	$(window).resize(function() {
		if ( $(window).width() < 1024 ) {
			owl.owlCarousel(owlOptions);
			owl.addClass('owl-carousel');
		} else {
			owl.removeClass('owl-carousel').trigger('destroy.owl.carousel');
			owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
		}
	});
});

// Testimonials Carousel
jQuery(document).ready(function($) {
	$('.section--testimonials .testimonials__carousel').owlCarousel({
		loop: true,
		dots: true,
		nav: false,
		items: 1,
		margin: 80
	});
});

// Case Studies
jQuery(document).ready(function($) {
	$('.section--casestudies .casestudies__carousel').owlCarousel({
		dots: false,
		nav: false,
		autoWidth:true,
		items: 1,
		responsive:{
			0:{
				loop: true,
				margin: 12,
			},
			480:{
				loop: true,
				margin: 20,
			},
			768:{
				loop: true,
				margin: 30,
			},
			1024: {
				loop: false,
				margin: 40
			},
			1280:{
				loop: false,
				margin: 45,
			},
			1440:{
				loop: false,
				margin: 50,
			},
			1920:{
				loop: false,
				margin: 56,
			},
		}
	});
});

// Banner
jQuery(document).ready(function($) {
	$('.section--banner .banner__carousel.owl-carousel').owlCarousel({
		loop: true,
		dots: false,
		nav: false,
		autoWidth:false,
		items: 1,
		margin: 56
	});
});

jQuery(document).ready(function($) {
	var owlBrands = $('.section--brands .brands__container'),
		owlOptions = {
			loop: true,
			nav: false,
			items: 1,
			autoWidth: true,
			responsive:{
				0:{
					margin: 12,
				},
				480:{
					margin: 20,
				},
				768:{
					margin: 30,
				},
			}
		};

	if ( $(window).width() < 1024 ) {
		owlBrands.owlCarousel(owlOptions);
		owlBrands.addClass('owl-carousel');
	} else {
		owlBrands.removeClass('owl-carousel');
	}

	$(window).resize(function() {
		if ( $(window).width() < 1024 ) {
			owlBrands.owlCarousel(owlOptions);
			owlBrands.addClass('owl-carousel');
		} else {
			owlBrands.removeClass('owl-carousel').trigger('destroy.owl.carousel');
			owlBrands.find('.owl-stage-outer').children(':eq(0)').unwrap();
		}
	});


	$('.section--brands .brands__carousel.owl-carousel').owlCarousel({
		loop: true,
		dots: false,
		nav: false,
		autoWidth:true,
		items: 1,
		responsive:{
			0:{
				margin: 24,
			},
			480:{
				margin: 30,
			},
			768:{
				margin: 40,
			},
			1920:{
				margin: 50,
			},
		}
	});

});

// FAQs
jQuery(document).ready(function($){
	function toggleFaq (elem) {
		if ( !elem.hasClass('active') ) {
			$('.faqs .faq').removeClass('active');
			elem.parent('.faq').addClass('active');
		}
	}

	$('.faqs .faq .faq__title').click(function(){
		toggleFaq( $(this) );
	});

	toggleFaq( $('.faqs .faq:first-child .faq__title') );
});

jQuery(document).ready(function($) {
	let mm = gsap.matchMedia();
	mm.add('(min-width:1024px)', () => {
		var sections = gsap.utils.toArray(".section--story .container--story");

		sections.forEach((section) => {
			ScrollTrigger.create({
				trigger: section,
				pin: $(section).find('.information .information__inner'),
				start: 'top top',
				scrub: true,
				end: "+=" + ( $(section).find('.story__images').outerHeight() - $(section).find('.information .info__block').outerHeight()),
				// markers: true
			});
		})
	});
});

jQuery(document).ready(function($) {
	$('.section--carousel .carousel__container').owlCarousel({
		autoWidth: false,
		loop: false,
		dots: true,
		nav: false,
		items: 1,
		margin: 0
	});
});

jQuery(document).ready(function($) {
	Marquee3k.init();
});

jQuery(document).ready(function($) {
	function checkOffset() {
		var socialFloat = document.querySelector('.spinner--whatsapp');
		var footer = document.querySelector('.footer > .shape__shadow');

		function getRectTop(el) {
			var rect = el.getBoundingClientRect();
			return rect.top;
		}

		if ((getRectTop(socialFloat) + document.body.scrollTop - (socialFloat.offsetHeight/2 - 20)) + socialFloat.offsetHeight >= (getRectTop(footer) + document.body.scrollTop) - 10) {
			socialFloat.classList.add('absolute');
			socialFloat.classList.remove('fixed');
		}

		if (document.body.scrollTop + window.innerHeight < (getRectTop(footer) + document.body.scrollTop + (socialFloat.offsetHeight/2 + 20))) {
			socialFloat.classList.add('fixed');
			socialFloat.classList.remove('absolute');
		}
	}
	checkOffset();

	document.addEventListener("scroll", function() {
		checkOffset();
	});
});

// Partners
jQuery(document).ready(function($) {
	$('.section--partners__list .partners .partner .partner__name').on('mouseenter', function() {
		$('.partners__images .partner__image').removeClass('active');
		$('.partners__images .partner__image[data-partner-image="' + $(this).parents('.partner').data('partner') + '"]').addClass('active');
	});

	$('.section--partners__list .partners .partner:first-child .partner__name').trigger('mouseenter');
});

jQuery(document).ready(function($) {
	$('.mute__btn').click(function() {
		var videos = $('video');
		var carousel__slide = $(this).parent('.carousel__slide');
		var video = carousel__slide.find('video');

		videos.each(function() {
			console.log( video[0] != $(this)[0] );
			if (video[0] != $(this)[0]) {
				$(this).prop('muted', 1);
				$(this).parent('.carousel__slide').find('.mute__btn').addClass('muted');
			}
		});

		if (video.prop('muted')) {
			video.prop('muted', !1);
			$(this).parent('.carousel__slide').find('.mute__btn').removeClass('muted');
		} else {
			video.prop('muted', !0);
			$(this).parent('.carousel__slide').find('.mute__btn').addClass('muted');
		}
	})
});

// Reload all marquee after images loaded to resolve glitch
jQuery(document).ready(function($) {
	$(window).load(function() {
		console.log('loaded');
		Marquee3k.refreshAll();
	});
});

jQuery(document).ready(function($) {
	$('header .menu .menu-item.menu-item-has-children .sub-menu').on('scroll', function() {
		var that = jQuery(this);
		var submenu = jQuery(this)[0];
		console.log( submenu.scrollTop );
		console.log( that.height() );
		console.log((submenu.scrollHeight - (that.height() + submenu.scrollTop)));

		if ( (submenu.scrollHeight - (that.height() + submenu.scrollTop)) > 1 ) {
			that.removeClass('arrow_bottom_hidden');
		} else {
			that.addClass('arrow_bottom_hidden');
		}
		
		if ( submenu.scrollTop > 1 ) {
			that.removeClass('arrow_top_hidden');
		} else {
			that.addClass('arrow_top_hidden');
		}
	});

	$('header .menu .menu-item.menu-item-has-children .sub-menu').trigger('scroll');
});

// AOS Animation
jQuery(document).ready(function ($) {
	AOS.init();
});